/**
 * Authenticated fetch wrapper for Central API calls.
 *
 * Uses Bearer token authentication instead of credentials: 'include'.
 * Central API endpoints require JWT in the Authorization header.
 */
export function authFetch(
  url: string,
  token: string,
  options: RequestInit = {}
): Promise<Response> {
  const { headers, ...rest } = options;
  return fetch(url, {
    ...rest,
    headers: {
      ...headers,
      Authorization: `Bearer ${token}`,
    },
  });
}
